import type { SupWeb3VaultBalance } from "@/hooks/api/useTokenSuperpositionsBalances";
import { useMemo } from "react";

import useRewardSettings from "@/hooks/data/useRewardSettings";
import { getNetVaultApy, getVaultApy } from "@/utils";
import dictionaryConfig from "@/../config/dictionary.config";

export default function useCalculatePortfolioApy(superPositions: SupWeb3VaultBalance[]) {
  const rewardsSettings = useRewardSettings();

  return useMemo(() => {
    if (!superPositions || superPositions.length < 1) {
      return 0;
    }
    const dividend = superPositions.reduce(
      (acc, singlePosition) =>
        acc +
        (getVaultApy(singlePosition.vault) !== dictionaryConfig.statsDefaultValue
          ? getNetVaultApy(singlePosition.vault, rewardsSettings, undefined, true) * singlePosition.superposition_usd_value
          : 0),
      0
    );
    const divisor = superPositions.reduce(
      (acc, singlePosition) => acc - (getVaultApy(singlePosition.vault) !== dictionaryConfig.statsDefaultValue ? singlePosition.superposition_usd_value : 1) * -1,
      0
    );
    if (divisor === 0) {
      return 0;
    }
    return dividend / divisor;
  }, [rewardsSettings, superPositions]);
}
